import { render, staticRenderFns } from "./RightBarSettings.vue?vue&type=template&id=fde8c7c6&scoped=true&"
import script from "./RightBarSettings.vue?vue&type=script&lang=js&"
export * from "./RightBarSettings.vue?vue&type=script&lang=js&"
import style0 from "./RightBarSettings.vue?vue&type=style&index=0&id=fde8c7c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fde8c7c6",
  null
  
)

export default component.exports